import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import escapeRegex from 'lodash.escaperegexp';

import { fetchLabels, initLabels } from 'actions/labels';
import { setWorkflow } from 'actions/workflow';

import getFlowData from 'screens/data/data';

import { Box } from 'components';

import styles from './Home.scss';

class Home extends Component {
  componentDidMount() {
    const { setWorkflowData, fetchWorkflowLabels } = this.props;

    const rootElem = document.getElementById('simulator-root');
    this.flowId = Number(rootElem.getAttribute('data-workflow'));

    setWorkflowData({
      id: this.flowId,
      type: (this.flowId <= 2) ? 'gas' : 'diesel'
    });

    fetchWorkflowLabels(this.flowId);
  }

  componentWillReceiveProps(nextProps) {
    const {
      data,
      isFetched,
      isInitialized
    } = nextProps;

    if (isFetched && !isInitialized) {
      this.replacePlaceholders(data);
    }
  }

  replacePlaceholders(data) {
    const { initWorkflowLabels } = this.props;
    const flowData = getFlowData(this.flowId);
    let paramStr = JSON.stringify(flowData);

    if (paramStr) {
      Object.keys(data).forEach((key) => {
        if (paramStr.includes(key)) {
          const labelKey = `"x-label:${key}"`;
          const re = new RegExp(escapeRegex(labelKey), 'g');

          paramStr = paramStr.replace(re, `"${data[key]}"`);
        }
      });

      initWorkflowLabels(JSON.parse(paramStr));
    }
  }

  render() {
    return (
      <div className={styles.Home}>
        <Box />
      </div>
    );
  }
}

Home.defaultProps = {
  data: null,
  isFetched: false,
  isInitialized: false
};

Home.propTypes = {
  data: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ]),
  isFetched: PropTypes.bool,
  isInitialized: PropTypes.bool,
  fetchWorkflowLabels: PropTypes.func.isRequired,
  initWorkflowLabels: PropTypes.func.isRequired,
  setWorkflowData: PropTypes.func.isRequired
};

export default connect(({ labels }) => ({
  data: labels.data,
  isFetched: labels.fetched,
  isInitialized: labels.initialized
}), {
  fetchWorkflowLabels: fetchLabels,
  initWorkflowLabels: initLabels,
  setWorkflowData: setWorkflow
})(Home);



// WEBPACK FOOTER //
// ./src/pages/Home/Home.js